import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import HTMLViewerDialogBox from '../Commons/HTMLViewerDialogBox';

import { EditIcon, TrashIcon, NavigationIcon } from './Styles/Icons';
import {
	Container,
	ContainerHeading,
	ContainerBody,
	SectionHeading,
	UploadedImageGroup,
	LocalizationProvider,
	DatePicker,
	Button,
	FlexRow,
	FlexColumn,
	Message,
	TextArea,
	RadioGroup,
	Tabs,
	Tab,
	ButtonGroup,
	InputGroup,
	TextField,
	Select,
	Bold,
	MenuItem,
	Section,
	SectionRow,
	Number,
	Chip,
	InputAdornment,
	Table,
	TableBody,
	TableRow,
	TableHeader,
	SquareButton,
	TableHeaderColumn,
	TableContainer,
	TableColumn,
	TableHeaderRow,
	NavigationLink,
	InputMessage,
	FileUpload,
	Search,
	Pagination,
	ManufacturerMenuItem,
} from './Styles/AddSingleItem';

import { updateErrorMessage, updateSuccessMessage, updateMessage, updateError } from '../../actions/commonActions';
import { fetchFileUploadURL, uploadFile, createInventory, fetchInventory, updateInventory, fetchAutocompleteSubCategory, fetchAutocompleteSubSubCategory } from '../../actions/inventoryActionsV2';
import {
	STOCK_STATUS,
	validateSupplierProductId,
	validateKeyword,
	validateSearchText,
	formatCurrency,
	stripCurrency,
	validateURL,
	getRestrictedFields,
	isSpecialMarketRequired,
	isTaxableRequired,
	isSubCategoryRequired,
	isSubSubCategoryRequired,
	isGLCodeRequired,
	hideDSOInfo,
} from '../../commons/utils';

const s3BaseURL = 'https://s3.us-east-1.amazonaws.com/dentira-us-dentira.com/product-images';
const DialogIds = {
	HTML_VIEWER: 'html_viewer_dialog',
};

class AddSingleItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			filteredManufacturerOptions: [],
			filteredManufacturerCount: 0,
			manufacturerSearchText: '',
			manufacturerPageNumber: 0,
			manufacturerPageSize: 25,
			mappedDSOIds: [],
			datePickerOpen: false,
			enableCustomManufacturer: false,
			enableCustomMappedSupplier: false,
			enableCustomPackaging: false,
			htmlViewerDialogOpen: false,
			keyword: '',
			keywords: [],
			attributeIndex: -1,
			attributeKey: '',
			attributeValue: '',
			attributes: [],
		};
	}

	componentDidMount() {
		if (this.props.updateItem) {
			this.setDefaultState(this.setPropState);
		} else {
			this.setDefaultState(this.setFreshState);
		}
	}

	async componentDidUpdate(prevProps, prevState) {
		if (prevProps.supplier !== this.props.supplier) {
			this.setDefaultState(this.setFreshState);
		}

		if (prevState.manufacturerSearchText !== this.state.manufacturerSearchText) {
			let { manufacturerOptions } = this.props;
			let { manufacturerSearchText, manufacturerPageSize } = this.state;

			let manufacturerList = [];
			manufacturerList = manufacturerOptions.filter((option) => option.name.toUpperCase().includes(manufacturerSearchText.toUpperCase()));
			this.setState({
				manufacturerPageNumber: 0,
				filteredManufacturerCount: manufacturerList.length,
				filteredManufacturerOptions: manufacturerList.slice(0, manufacturerPageSize),
			});
		}

		if (prevState.manufacturerPageNumber !== this.state.manufacturerPageNumber) {
			let { manufacturerOptions } = this.props;
			let { manufacturerPageNumber, manufacturerPageSize } = this.state;

			this.setState({
				filteredManufacturerOptions: manufacturerOptions.slice(manufacturerPageNumber * manufacturerPageSize, (manufacturerPageNumber + 1) * manufacturerPageSize),
			});
		}

		if (prevState.manufacturerPageSize !== this.state.manufacturerPageSize) {
			let { manufacturerOptions } = this.props;
			let { manufacturerPageSize } = this.state;

			this.setState({
				manufacturerPageNumber: 0,
				filteredManufacturerOptions: manufacturerOptions.slice(0, manufacturerPageSize),
			});
		}

		if (this.state.category && prevState.category !== this.state.category) {
			let { category } = this.state;
			await this.props.fetchAutocompleteSubCategory(category);
			this.setState({
				subCategory: this.props.updateItem ? this.state.subCategory : '',
			});
		}

		if (isSubSubCategoryRequired(this.props.groupId) && this.state.subCategory && prevState.subCategory !== this.state.subCategory) {
			let { category, subCategory } = this.state;
			await this.props.fetchAutocompleteSubSubCategory(category, subCategory);
			this.setState({
				subSubCategory: this.props.updateItem ? this.state.subSubCategory : '',
			});
		}
	}

	setDefaultState = async (next = null) => {
		let { manufacturerOptions } = this.props;

		this.setState(
			{
				manufacturerPageNumber: 0,
				filteredManufacturerOptions: (manufacturerOptions || []).slice(0, this.state.manufacturerPageSize),
				filteredManufacturerCount: (manufacturerOptions || []).length,
				activeTab: 0,
				fileThroughUrl: '',
				customPackaging: '',
				customManufacturer: '',
				customMappedSupplier: '',
				error: { main: '' },
			},
			next
		);
	};

	setFreshState = () => {
		this.setState({
			scheduledAt: null,
			files: [],
			itemId: '',
			itemName: '',
			itemDescription: '',
			manufacturer: '',
			manufacturerSKU: '',
			uom: '',
			quantity: '',
			minQuantity: '',
			maxQuantity: '',
			incrQuantity: '',
			isSpecialMarket: false,
			isTaxable: true,
			packaging: '',
			stockStatus: '',
			mappedDSOIds: [],
			dsoPrivate: false,
			mappedSupplier: '',
			mappedSupplierProductId: '',
			pricePerItemSingle: '0',
			unspsc: '',
			keywords: [],
			attributes: [],
			productURL: '',
			category: '',
			subCategory: '',
			subSubCategory: '',
			glCode: '',
			searchText: '',
		});
	};

	setPropState = async () => {
		let { productId } = this.props;
		if (productId) {
			let productData = await this.props.fetchInventory(productId);
			let productState = {
				itemId: productId,
				itemName: productData.name || '',
				itemDescription: productData.description || '',
				manufacturer: productData.manufacturer_name || '',
				manufacturerSKU: productData.manufacturer_id || '',
				uom: productData.uom || '',
				quantity: productData.qty || '',
				minQuantity: productData.min_qty || '',
				maxQuantity: productData.max_qty || '',
				incrQuantity: productData.incr_qty || '',
				isSpecialMarket: productData.is_special_market || false,
				packaging: productData.pkg || '',
				stockStatus: productData.availability_status || '',
				mappedDSOIds: productData.group_ids || [],
				dsoPrivate: productData.group_private || false,
				mappedSupplier: productData.mapped_supplier || '',
				mappedSupplierProductId: productData.mapped_supplier_product_id || '',
				pricePerItemSingle: productData.price_list && productData.price_list['1'] ? productData.price_list['1'] : '0',
				isTaxable: productData.taxable && true,
				unspsc: productData.unspsc || '',
				keywords: productData.keywords || [],
				attributes: (productData.attrs && Object.keys(productData.attrs).map((key) => ({ key: key, value: productData.attrs[key] }))) || [],
				productURL: productData.product_url || '',
				category: productData.category || '',
				subCategory: productData.subcategory || '',
				subSubCategory: productData.subsubcategory || '',
				glCode: productData.gl_code || '',
				searchText: productData.search_txt || '',
			};
			let files = [];
			if (productData.image_urls)
				productData.image_urls.forEach((url, index) => {
					let fileNameSplit = url.split('/');
					files.push({
						name: fileNameSplit[fileNameSplit.length - 1],
						url: url,
					});
				});
			productState['files'] = files;

			this.setState({ ...productState });
		}
	};

	setActiveTab = (tab) => {
		this.setState({ activeTab: tab });
		if (tab === 0) {
		} else if (tab === 1) {
		} else {
		}
	};

	handleClose = () => {
		this.props.toggle();
	};

	handleImageUpload = async (files = this.state.files, index = 0) => {
		if (index < files.length) {
			let file = files[index];
			if (!file['url']) {
				let reader = new FileReader();
				reader.onload = async (e) => {
					let blob = new Blob([new Uint8Array(e.target.result)], {
						type: file.type,
					});
					let response = await this.props.fetchFileUploadURL(file.extension);
					if (response && response.upload_url) {
						await this.props.uploadFile(response.upload_url, blob, file.type);
						let fileLocation = {
							bucket: response.bucket,
							name: response.filename,
							path: response.path,
							type: file.type,
						};
						files[index]['fileLocation'] = fileLocation;
						files[index]['url'] = `${s3BaseURL}/${response.filename}`;
						this.handleImageUpload(files, index + 1);
					}
				};
				reader.readAsArrayBuffer(file.raw);
			}
			this.handleImageUpload(files, index + 1);
		} else {
			this.handleInput('files', files);
		}
	};

	handleAddImage = async (filesToUpload, files = this.state.files, index = 0) => {
		if (index < filesToUpload.length) {
			const file = filesToUpload[index];
			const reader = new FileReader();
			reader.onload = (e) => {
				let fileNameSplit = file.name.split('.');
				if (fileNameSplit.length > 1) {
					files.push({
						raw: file,
						name: file.name,
						type: file.type,
						src: e.target.result,
						extension: fileNameSplit[fileNameSplit.length - 1],
					});
					this.handleAddImage(filesToUpload, files, index + 1);
				} else {
					this.props.updateError(true, `Invalid File: ${file.name}`);
				}
			};
			reader.readAsDataURL(file);
		} else {
			this.handleInput('files', files, () => {
				this.handleImageUpload();
			});
		}
	};

	handleAddImageThroughURL = (url) => {
		if (url && validateURL(url)) {
			this.handleInput('fileThroughUrl', '');
			let files = this.state.files || [];
			let fileNameSplit = url.split('/');
			files.push({
				name: fileNameSplit[fileNameSplit.length - 1],
				url: url,
			});
			this.handleInput('files', files);
		} else {
			this.setError('fileThroughUrl', 'Invalid Image URL');
		}
	};

	handleRemoveImage = (e, indexToRemove) => {
		let files = [];
		this.state.files.forEach((file, index) => {
			if (index !== indexToRemove) files.push(file);
		});
		this.handleInput('files', files);
	};

	handleDialogOnTrue = async (dialogId, value) => {
		switch (dialogId) {
			case DialogIds.HTML_VIEWER:
				this.setState({ htmlViewerDialogOpen: false });
				break;

			default:
				break;
		}
	};

	handleDialogOnFalse = (dialogId) => {
		switch (dialogId) {
			case DialogIds.HTML_VIEWER:
				this.setState({ htmlViewerDialogOpen: false });
				break;

			default:
				break;
		}
	};

	handleInput = (key, value, next = null) => {
		this.setState(
			{
				[key]: value,
				error: { ...this.state.error, [key]: '' },
			},
			next
		);
	};

	handleDateSelectOpen = () => {
		this.setState({ datePickerOpen: true });
	};

	handleDateSelectClose = () => {
		this.setState({ datePickerOpen: false });
	};

	setError = (key, value) => {
		this.setState({ error: { ...this.state.error, [key]: value } });
	};

	setErrors = (errors) => {
		this.setState({ error: errors });
	};

	checkErrors = (inputs) => {
		const { packaging, enableCustomPackaging, customPackaging, quantity, mappedSupplierProductId, mappedSupplier, enableCustomMappedSupplier, customMappedSupplier, attributeKey, attributeValue } =
			this.state;
		const { groupId, updateItem, supplierMap, supplier, allowZeroPrice } = this.props;
		let isLivePriceSupplier = (supplierMap[supplier] || {}).is_price_fetched || false;
		const error = {};

		Object.keys(inputs).map((key) => {
			let value = inputs[key];

			switch (key) {
				case 'itemName':
					if (!value) {
						error['itemName'] = 'Item Name cannot be empty.';
					} else if (value && value.length > 150) {
						error['itemName'] = 'Item Name is too long.';
					}
					break;

				case 'itemId':
					if(!updateItem){
						if (!value) {
							error['itemId'] = 'Item ID cannot be empty.';
						} else if (value && value.length > 25) {
							error['itemId'] = 'Item ID is too long.';
						} else if (value && !validateSupplierProductId(value)) {
							error['itemId'] = 'Item ID is invalid.';
						}
					}
					break;

				case 'itemDescription':
					if (!value) {
						error['itemDescription'] = 'Item Description cannot be empty.';
					}
					break;

				case 'manufacturer':
				case 'customManufacturer':
					if (!value) {
						error['manufacturer'] = 'Manufacturer name cannot be empty.';
					} else if (value && value.length > 50) {
						error['manufacturer'] = 'Manufacturer name is too long.';
					}
					break;

				case 'manufacturerSKU':
					if (!value) {
						error['manufacturerSKU'] = 'Manufacturer SKU cannot be empty.';
					} else if (value && value.length > 25) {
						error['manufacturerSKU'] = 'Manufacturer SKU is too long.';
					}
					break;

				case 'category':
					if (!value) {
						error['category'] = 'Category cannot be empty.';
					}
					break;

				case 'subCategory':
					if (isSubCategoryRequired(groupId) && !value) {
						error['subCategory'] = 'Sub Category cannot be empty.';
					}
					break;

				case 'subSubCategory':
					if (isSubSubCategoryRequired(groupId) && !value) {
						error['subSubCategory'] = 'Sub Sub Category cannot be empty.';
					}
					break;

				case 'uom':
					if (!value) {
						error['uom'] = `UOM cannot be empty.`;
					}
					break;

				case 'quantity':
					value = parseFloat(value);
					if ((packaging || (enableCustomPackaging && customPackaging)) && !value) {
						error['quantity'] = `Quantity cannot be empty if Packaging is provided.`;
					} else if (value && value < 1) {
						error['quantity'] = `Quantity should be a positive number.`;
					}
					break;

				case 'packaging':
				case 'customPackaging':
					if (quantity && !value) {
						error['packaging'] = `Packaging cannot be empty if Quantity is provided.`;
					}
					break;

				case 'minQuantity':
					value = parseInt(value, 10);
					if (value && value < 1) {
						error['minQuantity'] = `Minimum quantity should be positive integer.`;
					}
					break;

				case 'maxQuantity':
					value = parseInt(value, 10);
					if (value && value < 1) {
						error['maxQuantity'] = `Maximum quantity should be positive integer.`;
					}
					break;

				case 'incrQuantity':
					value = parseInt(value, 10);
					if (value && value < 1) {
						error['incrQuantity'] = `Incremental quantity should be positive integer.`;
					}
					break;

				case 'mappedSupplier':
				case 'customMappedSupplier':
					if (mappedSupplierProductId && !value) {
						error['mappedSupplier'] = 'Mapped Supplier cannot be empty if Mapped Supplier Product ID is defined.';
					}
					break;

				case 'mappedSupplierProductId':
					if ((mappedSupplier || (enableCustomMappedSupplier && customMappedSupplier)) && !value) {
						error['mappedSupplierProductId'] = 'Mapped Supplier Product ID cannot be empty if Mapped Supplier is provided.';
					} else if (value && value.length > 25) {
						error['mappedSupplierProductId'] = 'Mapped Supplier Product ID is too long.';
					}
					break;

				case 'searchText':
					if (value && value.length > 200) {
						error['searchText'] = 'Alternate Text is too long.';
					} else if (value && !validateSearchText(value)) {
						error['searchText'] = 'Alternate Text is invalid.';
					}
					break;

				case 'keyword':
					if (value && value.length > 20) {
						error['keyword'] = 'Keyword is too long.';
					}
					break;

				case 'keywords':
					if (value && value.length > 10) {
						error['keyword'] = 'Keywords cannot be more than 10.';
					} else if (value && value.some((word) => word.length > 20 && !validateKeyword(word))) {
						error['keyword'] = 'Some keywords are invalid.';
					}
					break;

				case 'productURL':
					if (value && !validateURL(value)) {
						error['productURL'] = 'Product URL is invalid.';
					}
					break;

				case 'stockStatus':
					if (!updateItem && !isLivePriceSupplier) {
						if (!value) {
							error['stockStatus'] = 'Stock Status cannot be empty.';
						}
					}
					break;

				case 'pricePerItemSingle':
					if (!updateItem && !isLivePriceSupplier) {
						if (allowZeroPrice) {
							if (stripCurrency(value) === undefined || stripCurrency(value) === '') {
								error['pricePerItemSingle'] = 'Price Per Item cannot be empty.';
							}
						} else {
							if (!stripCurrency(value)) {
								error['pricePerItemSingle'] = 'Price Per Item cannot be $0. Please enter a valid price.';
							}
						}
					}
					break;

				case 'attributeKey':
					if (attributeValue && !value) {
						error['attributeKey'] = 'Attribute key cannot be empty.';
					} else if (value && value.length > 50) {
						error['attributeKey'] = 'Attribute value cannot be more than 50.';
					}
					break;

				case 'attributeValue':
					if (attributeKey && !value) {
						error['attributeValue'] = 'Attribute value cannot be empty.';
					} else if (value && value.length > 50) {
						error['attributeValue'] = 'Attribute value cannot be more than 50.';
					}
					break;

				default:
					break;
			}
		});

		this.setState({ error: { ...this.state.error, ...error } });
		return Object.keys(error).length > 0;
	};

	validateData = () => {
		const {
			itemName,
			itemId,
			itemDescription,
			manufacturer,
			enableCustomManufacturer,
			customManufacturer,
			manufacturerSKU,
			mappedSupplier,
			enableCustomMappedSupplier,
			customMappedSupplier,
			mappedSupplierProductId,
			stockStatus,
			pricePerItemSingle,
			uom,
			quantity,
			minQuantity,
			maxQuantity,
			incrQuantity,
			packaging,
			enableCustomPackaging,
			customPackaging,
			productURL,
			category,
			searchText,
			keywords,
			subCategory,
			subSubCategory,
		} = this.state;

		let inputs = {
			itemName: itemName,
			itemId: itemId,
			itemDescription: itemDescription,
			manufacturerSKU: manufacturerSKU,
			category: category,
			subCategory: subCategory,
			subSubCategory: subSubCategory,
			uom: uom,
			quantity: quantity,
			minQuantity: minQuantity,
			maxQuantity: maxQuantity,
			incrQuantity: incrQuantity,
			mappedSupplierProductId: mappedSupplierProductId,
			searchText: searchText,
			keywords: keywords,
			productURL: productURL,
			stockStatus: stockStatus,
			pricePerItemSingle: pricePerItemSingle,
		};

		if (!enableCustomManufacturer) inputs['manufacturer'] = manufacturer;
		else if (enableCustomManufacturer) inputs['manufacturer'] = customManufacturer;

		if (!enableCustomPackaging) inputs['packaging'] = packaging;
		else if (enableCustomPackaging) inputs['packaging'] = customPackaging;

		if (!enableCustomMappedSupplier) inputs['mappedSupplier'] = mappedSupplier;
		else if (enableCustomMappedSupplier) inputs['mappedSupplier'] = customMappedSupplier;

		if (this.checkErrors(inputs)) {
			this.props.updateError(true, 'Clear errors before saving.');
			return true;
		}

		return false;
	};

	handleSubmit = async () => {
		this.setErrors({});
		if (this.validateData()) {
			this.setState({ scheduledAt: null });
			return;
		}

		const {
			itemName,
			itemId,
			manufacturer,
			enableCustomManufacturer,
			customManufacturer,
			manufacturerSKU,
			itemDescription,
			category,
			subCategory,
			subSubCategory,
			glCode,
			uom,
			isSpecialMarket,
			packaging,
			enableCustomPackaging,
			customPackaging,
			quantity,
			minQuantity,
			maxQuantity,
			incrQuantity,
			mappedSupplier,
			enableCustomMappedSupplier,
			customMappedSupplier,
			mappedSupplierProductId,
			mappedDSOIds,
			dsoPrivate,
			searchText,
			keywords,
			unspsc,
			productURL,
			attributes,
			stockStatus,
			files,
			activeTab,
			pricePerItemSingle,
			scheduledAt,
			isTaxable,
		} = this.state;
		const { supplier, updateItem, groupId, supplierMap, restrictedFields } = this.props;
		let isLivePriceSupplier = (supplierMap[supplier] || {}).is_price_fetched || false;

		let requestObj = {
			name: itemName || '',
			supplier_product_id: itemId,
			manufacturer_name: (enableCustomManufacturer ? customManufacturer : manufacturer) || '',
			manufacturer_id: manufacturerSKU || '',
			description: itemDescription || '',
			category: category || '',
			subcategory: subCategory || '',
			uom: uom || '',
			pkg: ((enableCustomPackaging ? customPackaging : packaging) || '').toUpperCase(),
			qty: quantity || '',
			min_qty: minQuantity || '',
			max_qty: maxQuantity || '',
			incr_qty: incrQuantity || '',
			mapped_supplier: ((enableCustomMappedSupplier ? customMappedSupplier : mappedSupplier) || '').toUpperCase(),
			mapped_supplier_product_id: mappedSupplierProductId || '',
			group_ids: mappedDSOIds || [],
			group_private: mappedDSOIds.length ? dsoPrivate : false,
			search_txt: searchText || '',
			keywords: keywords || [],
			unspsc: unspsc || '',
			product_url: productURL || '',
			image_urls: [],
			attrs: {},
			scheduled_at: null,
		};

		if (isSpecialMarketRequired(supplier)) {
			requestObj.is_special_market = isSpecialMarket;
		}

		if (isTaxableRequired(groupId)) {
			requestObj.taxable = isTaxable;
		}

		if (isSubSubCategoryRequired(groupId)) {
			requestObj.subsubcategory = subSubCategory;
		}

		if (isGLCodeRequired(groupId) && glCode) {
			requestObj.gl_code = glCode;
		}

		if (attributes.length) {
			let attrs = {};
			attributes.map((attribute) => {
				attrs[attribute.key] = attribute.value;
			});
			requestObj.attrs = attrs;
		}

		if (files && files.length) {
			files.forEach((file, index) => {
				requestObj.image_urls.push(file.url);
			});
		}

		if (scheduledAt) {
			let date = scheduledAt.getDate() < 10 ? `0${scheduledAt.getDate()}` : `${scheduledAt.getDate()}`;
			let month = scheduledAt.getMonth() < 10 ? `0${scheduledAt.getMonth() + 1}` : `${scheduledAt.getMonth() + 1}`;
			let year = scheduledAt.getFullYear();
			requestObj.scheduled_at = `${year}-${month}-${date}`;
		}

		let response;
		if (updateItem) {
			response = await this.props.updateInventory(this.props.productId, requestObj);
		} else {
			if (activeTab === 0) {
				if (!isLivePriceSupplier) {
					requestObj['price_list'] = { 1: String(stripCurrency(pricePerItemSingle) || 0) };
				}
			} else if (activeTab === 1) {
				// parse the mrp object
			}

			if (!isLivePriceSupplier) {
				requestObj['availability_status'] = stockStatus;
			}

			response = await this.props.createInventory(requestObj);
		}

		if (restrictedFields.length) {
			restrictedFields.forEach((field) => {
				delete requestObj[field];
			});
		}

		if (response) {
			this.handleClose();
			this.props.updateSuccessMessage(true, `Item ${this.props.updateItem ? 'update' : 'add'} request added successfully. Item Id: ${requestObj.supplier_product_id}`);
			await this.props.onSuccess();
		}
	};

	render() {
		let {
			error,
			activeTab,
			htmlViewerDialogOpen,
			datePickerOpen,
			scheduledAt,
			itemName,
			itemId,
			itemDescription,
			files,
			fileThroughUrl,
			manufacturer,
			enableCustomManufacturer,
			customManufacturer,
			manufacturerSKU,
			manufacturerSearchText,
			manufacturerPageSize,
			manufacturerPageNumber,
			filteredManufacturerOptions,
			filteredManufacturerCount,
			mappedSupplier,
			enableCustomMappedSupplier,
			customMappedSupplier,
			mappedSupplierProductId,
			stockStatus,
			pricePerItemSingle,
			mappedDSOIds,
			dsoPrivate,
			uom,
			isSpecialMarket,
			quantity,
			minQuantity,
			maxQuantity,
			incrQuantity,
			packaging,
			enableCustomPackaging,
			customPackaging,
			unspsc,
			productURL,
			keyword,
			keywords,
			attributes,
			attributeIndex,
			attributeKey,
			attributeValue,
			category,
			subCategory,
			subSubCategory,
			glCode,
			searchText,
			isTaxable,
		} = this.state;
		let {
			supplier,
			open,
			updateItem,
			groupId,
			mappedSupplierOptions,
			mappedDSOOptions,
			uomOptions,
			packagingOptions,
			categoryOptions,
			subCategoryOptions,
			subSubCategoryOptions,
			supplierMap,
			restrictedFields,
			allowZeroPrice
		} = this.props;

		let isLivePriceSupplier = (supplierMap[supplier] || {}).is_price_fetched || false;

		return (
			<Container open={open}>
				<Helmet>
					<title>Seller Portal | Inventory | {updateItem ? 'Update' : 'Add'} Single Item</title>
				</Helmet>

				<HTMLViewerDialogBox
					key={DialogIds.HTML_VIEWER}
					open={htmlViewerDialogOpen}
					text={itemDescription || ''}
					onTrue={() => this.handleDialogOnTrue(DialogIds.HTML_VIEWER)}
					onFalse={() => this.handleDialogOnFalse(DialogIds.HTML_VIEWER)}
				/>

				<ContainerHeading>
					{updateItem ? 'Update' : 'Add'} Single Item
					<ButtonGroup alignRight>
						<Button
							secondary
							outline
							onClick={this.handleClose}
						>
							Cancel
						</Button>

						{!updateItem ? (
							<LocalizationProvider>
								<DatePicker
									value={scheduledAt}
									open={datePickerOpen}
									disableCloseOnSelect={false}
									disableHighlightToday={true}
									shouldDisableDate={(date) => date <= new Date()}
									onChange={(date) =>
										this.handleInput('scheduledAt', date, () => {
											this.handleSubmit();
										})
									}
									onClose={() => this.handleDateSelectClose()}
									renderInput={(props) => (
										<Button
											secondary
											onClick={(e) => {
												this.handleDateSelectOpen();
											}}
										>
											Schedule And Save
										</Button>
									)}
									PopperProps={{ style: { position: 'relative' } }}
								/>
							</LocalizationProvider>
						) : null}

						<Button
							secondary
							onClick={this.handleSubmit}
						>
							Save
						</Button>
					</ButtonGroup>
				</ContainerHeading>

				<ContainerBody>
					<FlexRow responsive='1200px'>
						<FlexColumn style={{ flex: '1' }}>
							<Section style={{ position: 'sticky', top: '0' }}>
								<SectionHeading>Quick Navigation</SectionHeading>

								<SectionRow style={{ alignItems: 'center' }}>
									<FlexColumn style={{ width: '100%' }}>
										<NavigationLink href='#instruction'>
											<NavigationIcon />
											Instructions
										</NavigationLink>

										<NavigationLink href='#item-information'>
											<NavigationIcon />
											Item Information
										</NavigationLink>

										{!updateItem && !isLivePriceSupplier ? (
											<NavigationLink href='#pricing-information'>
												<NavigationIcon />
												Pricing Information
											</NavigationLink>
										) : null}

										{!updateItem && !isLivePriceSupplier ? (
											<NavigationLink href='#stock-status'>
												<NavigationIcon />
												Stock Status
											</NavigationLink>
										) : null}

										<NavigationLink href='#upload-images'>
											<NavigationIcon />
											Upload Images
										</NavigationLink>

										<NavigationLink href='#category-information'>
											<NavigationIcon />
											Category Information
										</NavigationLink>

										<NavigationLink href='#packaging-information'>
											<NavigationIcon />
											Packaging Information
										</NavigationLink>

										{/* <NavigationLink href="#supplier-information">
                                            <NavigationIcon/>
                                            Supplier Information
                                        </NavigationLink> */}

										{!hideDSOInfo(groupId) ? (
											<NavigationLink href='#dso-information'>
												<NavigationIcon />
												DSO Information
											</NavigationLink>
										) : null}

										<NavigationLink href='#additional-information'>
											<NavigationIcon />
											Additional Information
										</NavigationLink>
									</FlexColumn>
								</SectionRow>
							</Section>
						</FlexColumn>

						<FlexColumn style={{ flex: '3' }}>
							<Section id='instruction'>
								<SectionHeading>Instructions</SectionHeading>

								<SectionRow style={{ alignItems: 'center' }}>
									<Message>* marked fields are required.</Message>
								</SectionRow>
							</Section>

							<Section id='item-information'>
								<SectionHeading>Item Information</SectionHeading>

								<SectionRow>
									<InputGroup
										label='Item Name'
										markRequired={true}
										inputLength={(itemName || '').length}
										maxLength={150}
										error={error && error.itemName}
									>
										<TextField
											name={'item_name'}
											disabled={false}
											placeholder='Enter value'
											value={itemName}
											onChange={(e) => {
												this.handleInput('itemName', e.target.value);
											}}
											onKeyUp={(e) => {
												this.checkErrors({ itemName: e.target.value });
											}}
											error={error && error.itemName}
										/>
									</InputGroup>

									<InputGroup
										label='Item ID'
										markRequired={true}
										inputLength={(itemId || '').length}
										maxLength={25}
										message={'Item ID cannot contain underscore(_) and colon(:).'}
										error={error && error.itemId}
									>
										<TextField
											name={'item_id'}
											disabled={updateItem}
											placeholder='Enter value'
											value={itemId}
											onChange={(e) => {
												this.handleInput('itemId', e.target.value);
											}}
											onKeyUp={(e) => {
												this.checkErrors({ itemId: e.target.value });
											}}
											error={error && error.itemId}
										/>
									</InputGroup>

									<InputGroup
										label='Manufacturer'
										markRequired={true}
										inputLength={(customManufacturer || '').length}
										maxLength={enableCustomManufacturer && 50}
										error={error && error.manufacturer}
									>
										<Select
											name='manufacturer'
											placeholder='Select value'
											value={manufacturer || ''}
											disabled={false}
											onChange={(e) => {
												this.handleInput('manufacturer', e.target.value);
											}}
											error={error && error.manufacturer}
										>
											<MenuItem
												disabled={false}
												divider
												onClickCapture={(e) => {
													e.stopPropagation();
													e.preventDefault();
												}}
												onKeyDown={(e) => e.stopPropagation()}
											>
												<Search
													searchText={manufacturerSearchText}
													placeholder={'Search Manufacturer'}
													searchOnChange={true}
													onSearchHandler={(value) => this.setState({ manufacturerSearchText: value })}
												/>
											</MenuItem>

											<MenuItem
												key='ADD NEW OPTION'
												value='ADD NEW OPTION'
												onClick={(e) => {
													this.setState({ enableCustomManufacturer: true });
												}}
											>
												<Bold>ADD NEW OPTION</Bold>
											</MenuItem>

											{manufacturer ? (
												<MenuItem
													key={'selected-item'}
													value={manufacturer}
													disabled={true}
													onClick={(e) => {}}
													style={{ display: 'none' }}
												>
													{manufacturer}
												</MenuItem>
											) : null}

											{filteredManufacturerCount === 0 ? (
												<MenuItem
													key={'NO MANUFACTURER OPTIONS AVAILABLE'}
													value={''}
													disabled={true}
												>
													NO MANUFACTURER OPTIONS AVAILABLE
												</MenuItem>
											) : null}

											{filteredManufacturerOptions.map((item) => (
												<ManufacturerMenuItem
													key={item.value}
													value={item.value}
													disabled={item.disabled}
													onClick={(e) => {
														this.setState({ enableCustomManufacturer: false });
													}}
												>
													{item.name}
												</ManufacturerMenuItem>
											))}

											<Pagination
												component='div'
												count={filteredManufacturerCount || 0}
												page={manufacturerPageNumber}
												onPageChange={(e, page) => {
													this.setState({ manufacturerPageNumber: parseInt(page, 10) });
												}}
												rowsPerPage={manufacturerPageSize}
												onRowsPerPageChange={(e) => {
													this.setState({ manufacturerPageSize: parseInt(e.target.value, 10), manufacturerPageNumber: 0 });
												}}
											/>
										</Select>

										{enableCustomManufacturer ? (
											<TextField
												name={'custom_manfacturer_sku'}
												disabled={false}
												placeholder='Enter new option in this field.'
												value={customManufacturer}
												onChange={(e) => {
													this.handleInput('customManufacturer', e.target.value);
												}}
												onKeyUp={(e) => {
													this.checkErrors({ customManufacturer: e.target.value });
												}}
												error={error && error.manufacturer}
											/>
										) : null}
									</InputGroup>

									<InputGroup
										label='Manufacturer SKU'
										markRequired={true}
										inputLength={(manufacturerSKU || '').length}
										maxLength={25}
										error={error && error.manufacturerSKU}
									>
										<TextField
											name={'manufacturer_sku'}
											disabled={false}
											placeholder='Enter value'
											value={manufacturerSKU}
											onChange={(e) => {
												this.handleInput('manufacturerSKU', e.target.value);
											}}
											onKeyUp={(e) => {
												this.checkErrors({ manufacturerSKU: e.target.value });
											}}
											error={error && error.manufacturerSKU}
										/>
									</InputGroup>
								</SectionRow>

								<SectionRow>
									<InputGroup
										label='Item Description'
										markRequired={true}
										error={error && error.itemDescription}
									>
										<TextArea
											rows={5}
											name={'item_description'}
											disabled={false}
											placeholder='Enter value'
											value={itemDescription}
											onChange={(e) => {
												this.handleInput('itemDescription', e.target.value);
											}}
											error={error && error.itemDescription}
										/>

										{itemDescription ? (
											<Bold
												style={{ cursor: 'pointer' }}
												onClick={(e) => this.setState({ htmlViewerDialogOpen: true })}
											>
												Preview Description
											</Bold>
										) : null}
									</InputGroup>
								</SectionRow>
							</Section>

							{(!isLivePriceSupplier && !updateItem) || isTaxableRequired(groupId) ? (
								<Section id='pricing-information'>
									<SectionHeading>Pricing Information</SectionHeading>

									{!isLivePriceSupplier && !updateItem ? (
										<Tabs style={{ borderWidth: '0px' }}>
											<Tab
												active={activeTab === 0}
												onClick={() => {
													this.setActiveTab(0);
												}}
											>
												Single Item Pricing
											</Tab>

											<Tab
												active={activeTab === 1}
												title={'Feature under development.'}
												onClick={() => {
													return false;
												}}
											>
												Bulk Pricing
											</Tab>
										</Tabs>
									) : null}

									<SectionRow>
										{!isLivePriceSupplier && !updateItem ? (
											<>
												{activeTab === 0 ? (
													<InputGroup
														label={'Price Per Item'}
														markRequired={true}
														message={allowZeroPrice ? 'You can set the price as 0 as well.' : ''}
														error={error && error.pricePerItemSingle}
													>
														<TextField
															disabled={false}
															placeholder='$0.00'
															name={'price_per_item_single'}
															value={formatCurrency(pricePerItemSingle) || '0'}
															onBlur={(e) => {
																this.handleInput('pricePerItemSingle', stripCurrency(formatCurrency(e.target.value, true)));
															}}
															onChange={(e) => {
																this.handleInput('pricePerItemSingle', formatCurrency(e.target.value));
															}}
															error={error && error.pricePerItemSingle}
														/>
													</InputGroup>
												) : null}

												{activeTab === 1 ? <>Under Development</> : null}
											</>
										) : null}

										{isTaxableRequired(groupId) ? (
											<InputGroup
												label='Is Taxable?'
												markRequired={isTaxableRequired(groupId)}
												error={error && error.isTaxable}
											>
												<RadioGroup
													name={'is_taxable'}
													disabled={false}
													value={isTaxable}
													onClick={(e) => {
														this.handleInput('isTaxable', e.target.value === 'true');
													}}
													error={error && error.isTaxable}
													options={[
														{ name: 'Yes', value: true },
														{ name: 'No', value: false },
													]}
												/>
											</InputGroup>
										) : null}

										<InputGroup />
									</SectionRow>
								</Section>
							) : null}

							{!updateItem && !isLivePriceSupplier ? (
								<Section id='stock-status'>
									<SectionHeading>Stock Status</SectionHeading>

									<SectionRow>
										<InputGroup
											label='Select Status'
											markRequired={true}
											error={error && error.stockStatus}
										>
											<RadioGroup
												name={'stock_status'}
												disabled={false}
												value={stockStatus}
												onClick={(e) => {
													this.handleInput('stockStatus', e.target.value);
												}}
												error={error && error.stockStatus}
												options={Object.keys(STOCK_STATUS).map((code) => ({ name: STOCK_STATUS[code], value: code, disabled: false }))}
											/>
										</InputGroup>

										<InputGroup></InputGroup>
									</SectionRow>
								</Section>
							) : null}

							<Section id='upload-images'>
								<SectionHeading>Upload Images</SectionHeading>

								<SectionRow>
									<ButtonGroup alignLeft>
										<FileUpload
											multiple
											secondary
											label='Upload Images'
											accept='.jpg,.jpeg,.png,.webp'
											onInput={(e) => {
												this.handleAddImage(e.target.files);
											}}
										/>

										<span style={{ alignSelf: 'center' }}>Or</span>
									</ButtonGroup>
								</SectionRow>

								<SectionRow style={{ alignItems: 'center' }}>
									<InputGroup error={error && error.fileThroughUrl}>
										<TextField
											placeholder='Paste image url and press enter.'
											name='file_through_url'
											value={fileThroughUrl}
											onKeyDown={(e) => {
												if (e.key === 'Enter') {
													this.handleAddImageThroughURL(e.target.value);
												}
											}}
											onChange={(e) => {
												this.handleInput('fileThroughUrl', e.target.value);
											}}
											error={error && error.fileThroughUrl}
										/>
									</InputGroup>

									<ButtonGroup alignRight>
										<Button
											secondary
											onClick={(e) => this.handleAddImageThroughURL(fileThroughUrl)}
										>
											Add URL
										</Button>
									</ButtonGroup>
								</SectionRow>

								<Message>{error && error.files}</Message>

								{files && files.length ? (
									<>
										<SectionHeading>Uploaded Images</SectionHeading>

										<SectionRow style={{ rowGap: '0.5rem', columnGap: '0.5rem' }}>
											{files.map((file, index) =>
												file.url ? (
													<UploadedImageGroup
														key={index}
														src={file.url}
														uploaded={file.url ? true : false}
														name={file.name}
														onRemoveHandler={(e) => {
															this.handleRemoveImage(e, index);
														}}
													/>
												) : null
											)}
										</SectionRow>
									</>
								) : null}
							</Section>

							<Section id='category-information'>
								<SectionHeading>Category Information</SectionHeading>

								<SectionRow>
									<InputGroup
										label='Category'
										markRequired={true}
										error={error && error.category}
									>
										<Select
											name={'category'}
											placeholder='Select value'
											value={category || ''}
											disabled={false}
											onChange={(e) => {
												this.handleInput('category', e.target.value);
											}}
											error={error && error.category}
										>
											{!categoryOptions.length ? (
												<MenuItem
													key={'NO CATEGORY OPTIONS AVAILABLE'}
													value={''}
													disabled={true}
												>
													NO CATEGORY OPTIONS AVAILABLE
												</MenuItem>
											) : null}

											{categoryOptions.map((item) => (
												<MenuItem
													key={item.value}
													value={item.value}
													disabled={item.disabled}
												>
													{item.name}
												</MenuItem>
											))}
										</Select>
									</InputGroup>

									<InputGroup
										label='Sub Category'
										markRequired={isSubCategoryRequired(groupId)}
										error={error && error.subCategory}
									>
										<Select
											name={'sub_category'}
											placeholder='Select value'
											value={subCategory || ''}
											disabled={!category}
											onChange={(e) => {
												this.handleInput('subCategory', e.target.value);
											}}
											error={error && error.subCategory}
										>
											{!subCategoryOptions.length ? (
												<MenuItem
													key={'NO SUB CATEGORY OPTIONS AVAILABLE'}
													value={''}
													disabled={true}
												>
													NO SUB CATEGORY OPTIONS AVAILABLE
												</MenuItem>
											) : null}

											<MenuItem
												key={''}
												value={''}
												disabled={false}
											>
												None
											</MenuItem>

											{subCategoryOptions.map((item) => (
												<MenuItem
													key={item.value}
													value={item.value}
													disabled={item.disabled}
												>
													{item.name}
												</MenuItem>
											))}
										</Select>
									</InputGroup>

									{isSubSubCategoryRequired(groupId) ? (
										<InputGroup
											label='Sub Sub Category'
											markRequired={isSubSubCategoryRequired(groupId)}
											error={error && error.subSubCategory}
										>
											<Select
												name={'sub_sub_category'}
												placeholder='Select value'
												value={subSubCategory || ''}
												disabled={!subCategory}
												onChange={(e) => {
													this.handleInput('subSubCategory', e.target.value);
												}}
												error={error && error.subSubCategory}
											>
												{!subSubCategoryOptions.length ? (
													<MenuItem
														key={'NO SUB SUB CATEGORY OPTIONS AVAILABLE'}
														value={''}
														disabled={true}
													>
														NO SUB SUB CATEGORY OPTIONS AVAILABLE
													</MenuItem>
												) : null}

												<MenuItem
													key={''}
													value={''}
													disabled={false}
												>
													None
												</MenuItem>

												{subSubCategoryOptions.map((item) => (
													<MenuItem
														key={item.value}
														value={item.value}
														disabled={item.disabled}
													>
														{item.name}
													</MenuItem>
												))}
											</Select>
										</InputGroup>
									) : null}

									{isGLCodeRequired(groupId) ? (
										<InputGroup
											label='GL Code'
											error={error && error.glCode}
										>
											<TextField
												name={'gl_code'}
												disabled={false}
												placeholder='Enter value'
												value={glCode}
												onChange={(e) => {
													this.handleInput('glCode', e.target.value);
												}}
												error={error && error.glCode}
											/>
										</InputGroup>
									) : null}
								</SectionRow>
							</Section>

							<Section id='packaging-information'>
								<SectionHeading>Packaging Information</SectionHeading>

								<SectionRow>
									<InputGroup
										label='UOM'
										markRequired={true}
										error={error && error.uom}
									>
										<Select
											name={'uom'}
											placeholder='Select value'
											value={uom || ''}
											disabled={false}
											onChange={(e) => {
												this.handleInput('uom', e.target.value);
											}}
											error={error && error.uom}
										>
											{/* <MenuItem 
                                                key="ADD NEW OPTION"
                                                value="ADD NEW OPTION"
                                                onClick={(e) => {
                                                    this.setState({enableCustomPackaging:true})
                                                }}
                                            >
                                                <Bold>ADD NEW OPTION</Bold>
                                            </MenuItem> */}

											{!uomOptions.length ? (
												<MenuItem
													key={'NO UOM OPTIONS AVAILABLE'}
													value={''}
													disabled={true}
												>
													NO UOM OPTIONS AVAILABLE
												</MenuItem>
											) : null}

											{uomOptions.map((item) => (
												<MenuItem
													key={item.value}
													value={item.value}
													disabled={item.disabled}
													onClick={(e) => {
														this.setState({ enableCustomPackaging: false });
													}}
												>
													{item.name}
												</MenuItem>
											))}
										</Select>
									</InputGroup>

									{isSpecialMarketRequired(supplier) ? (
										<InputGroup
											label='Is Special Market?'
											markRequired={false}
											error={error && error.isSpecialMarket}
										>
											<RadioGroup
												name={'is_special_market'}
												disabled={false}
												value={isSpecialMarket}
												onClick={(e) => {
													this.handleInput('isSpecialMarket', e.target.value === 'true');
												}}
												error={error && error.isSpecialMarket}
												options={[
													{ name: 'Yes', value: true },
													{ name: 'No', value: false },
												]}
											/>
										</InputGroup>
									) : null}

									<InputGroup
										label='Packaging'
										markRequired={false}
										inputLength={(customPackaging || '').length}
										maxLength={enableCustomPackaging && 25}
										error={error && error.packaging}
									>
										<Select
											name={'packaging'}
											placeholder='Select value'
											value={packaging || ''}
											disabled={false}
											onChange={(e) => {
												this.handleInput('packaging', e.target.value);
											}}
											error={error && error.packaging}
										>
											{/* <MenuItem 
                                                key="ADD NEW OPTION"
                                                value="ADD NEW OPTION"
                                                onClick={(e) => {
                                                    this.setState({enableCustomPackaging:true})
                                                }}
                                            >
                                                <Bold>ADD NEW OPTION</Bold>
                                            </MenuItem> */}

											{!packagingOptions.length ? (
												<MenuItem
													key={'NO PACKAGING OPTIONS AVAILABLE'}
													value={''}
													disabled={true}
												>
													NO PACKAGING OPTIONS AVAILABLE
												</MenuItem>
											) : null}

											{packagingOptions.map((item) => (
												<MenuItem
													key={item.value}
													value={item.value}
													disabled={item.disabled}
													onClick={(e) => {
														this.setState({ enableCustomPackaging: false });
													}}
												>
													{item.name}
												</MenuItem>
											))}
										</Select>

										{enableCustomPackaging ? (
											<TextField
												name={'custom_packaging'}
												disabled={false}
												placeholder='Enter new option in this field.'
												value={customPackaging}
												onChange={(e) => {
													this.handleInput('customPackaging', e.target.value);
												}}
												onKeyUp={(e) => {
													this.checkErrors({ customPackaging: e.target.value });
												}}
												error={error && error.packaging}
											/>
										) : null}
									</InputGroup>

									<InputGroup
										label='Quantity'
										markRequired={false}
										error={error && error.quantity}
									>
										<Number
											name={'quantity'}
											disabled={false}
											placeholder='Enter value'
											value={quantity}
											onChange={(e) => {
												this.handleInput('quantity', e.target.value);
											}}
											onKeyUp={(e) => {
												this.checkErrors({ quantity: e.target.value });
											}}
											error={error && error.quantity}
										/>
									</InputGroup>

									<InputGroup>{/* To maintain dimensions */}</InputGroup>
								</SectionRow>

								<SectionHeading>Ordering Quantity Information</SectionHeading>

								<SectionRow>
									<InputGroup
										label='Minimum Quantity'
										markRequired={false}
										message='You may set the minimum ordering quantity for this item.'
										error={error && error.minQuantity}
									>
										<Number
											name={'min_quantity'}
											disabled={false}
											placeholder='Enter value'
											value={minQuantity}
											onKeyDown={(e) => {
												if (e.key === '.') e.preventDefault();
											}}
											onChange={(e) => {
												this.handleInput('minQuantity', e.target.value);
											}}
											onKeyUp={(e) => {
												this.checkErrors({ minQuantity: e.target.value });
											}}
											error={error && error.minQuantity}
										/>
									</InputGroup>

									<InputGroup
										label='Maximum Quantity'
										markRequired={false}
										message='You may set the maximum ordering quantity for this item.'
										error={error && error.maxQuantity}
									>
										<Number
											name={'max_quantity'}
											disabled={false}
											placeholder='Enter value'
											value={maxQuantity}
											onKeyDown={(e) => {
												if (e.key === '.') e.preventDefault();
											}}
											onChange={(e) => {
												this.handleInput('maxQuantity', e.target.value);
											}}
											onKeyUp={(e) => {
												this.checkErrors({ maxQuantity: e.target.value });
											}}
											error={error && error.maxQuantity}
										/>
									</InputGroup>

									<InputGroup
										label='Incremental Quantity'
										markRequired={false}
										message='You may set the increment on ordering quantity for this item.'
										error={error && error.incrQuantity}
									>
										<Number
											name={'incr_quantity'}
											disabled={false}
											placeholder='Enter value'
											value={incrQuantity}
											onKeyDown={(e) => {
												if (e.key === '.') e.preventDefault();
											}}
											onChange={(e) => {
												this.handleInput('incrQuantity', e.target.value);
											}}
											onKeyUp={(e) => {
												this.checkErrors({ incrQuantity: e.target.value });
											}}
											error={error && error.incrQuantity}
										/>
									</InputGroup>

									<InputGroup>{/* To maintain dimensions */}</InputGroup>
								</SectionRow>
							</Section>

							{/* <Section id="supplier-information">
                                <SectionHeading>
                                    Supplier Information
                                </SectionHeading>

                                <SectionRow>
                                    <InputGroup 
                                        label="Mapped Supplier" 
                                        markRequired={false} 
                                        error={error && error.mappedSupplier}
                                    >
                                        <Select
                                            name={"mapped_supplier"}
                                            placeholder="Select value"
                                            value={(mappedSupplier || "")}
                                            disabled={false}
                                            onChange={(e)=>{
                                                this.handleInput("mappedSupplier",  e.target.value)
                                            }}
                                            error={error && error.mappedSupplier}
                                        >
                                            <MenuItem 
                                                key="ADD NEW OPTION"
                                                value="ADD NEW OPTION"
                                                onClick={(e) => {
                                                    this.setState({enableCustomMappedSupplier:true})
                                                }}
                                            >
                                                <Bold>ADD NEW OPTION</Bold>
                                            </MenuItem>

                                            {!(mappedSupplierOptions.length)
                                            ?    <MenuItem 
                                                    key={"NO SUPPLIER OPTIONS AVAILABLE"}
                                                    value={""} 
                                                    disabled={true}
                                                >
                                                    NO SUPPLIERS OPTIONS AVAILABLE
                                                </MenuItem>
                                            :null
                                            }

                                            {mappedSupplierOptions.map((item) => (
                                                <MenuItem 
                                                    key={item.value}
                                                    value={item.value} 
                                                    disabled={item.disabled}
                                                    onClick={(e) => {
                                                        this.setState({enableCustomMappedSupplier:false})
                                                    }}
                                                >
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                        </Select>

                                        {enableCustomMappedSupplier
                                        ?   <TextField
                                                name={"custom_mapped_supplier"}
                                                disabled={false}
                                                placeholder="Enter new option in this field."
                                                value={customMappedSupplier}
                                                onChange={(e)=>{
                                                    this.handleInput("customMappedSupplier", e.target.value)
                                                }}
                                                error={error && error.mappedSupplier}
                                            />
                                        :   null
                                        }
                                    </InputGroup>  

                                    <InputGroup 
                                        label="Mapped Supplier Product ID" 
                                        markRequired={false} 
                                        error={error && error.mappedSupplierProductId}
                                    >
                                        <TextField
                                            name={"mapped_supplier_product_id"}
                                            disabled={false}
                                            placeholder="Enter value"
                                            value={mappedSupplierProductId}
                                            onChange={(e)=>{
                                                this.handleInput("mappedSupplierProductId", e.target.value)
                                            }}
                                            error={error && error.mappedSupplierProductId}
                                        />
                                    </InputGroup>
                                </SectionRow>
                            </Section> */}

							{!(hideDSOInfo(groupId) || (restrictedFields.includes('group_ids') && restrictedFields.includes('group_private'))) ? (
								<Section id='dso-information'>
									<SectionHeading>DSO Information</SectionHeading>

									<SectionRow>
										{!restrictedFields.includes('group_ids') ? (
											<InputGroup
												label='Map To Particular DSOs'
												markRequired={false}
												message={'Dentira has separate/restricted catalog view for above 6 DSOs. If item needs to be available for them, please select from above dropdown.'}
												error={error && error.mappedDSOIds}
											>
												<Select
													multiple
													name={'mapped_dso_ids'}
													placeholder='Select value'
													value={mappedDSOIds.length ? mappedDSOIds : []}
													disabled={false}
													onChange={(e) => {
														this.handleInput('mappedDSOIds', e.target.value);
													}}
													error={error && error.mappedDSOIds}
												>
													{!mappedDSOOptions.length ? (
														<MenuItem
															key={'NO DSO OPTIONS AVAILABLE'}
															value={''}
															disabled={true}
														>
															NO DSO OPTIONS AVAILABLE
														</MenuItem>
													) : null}

													{mappedDSOOptions.map((item) => (
														<MenuItem
															key={item.value}
															value={item.value}
															disabled={item.disabled}
														>
															{item.name}
														</MenuItem>
													))}
												</Select>
											</InputGroup>
										) : null}

										{!restrictedFields.includes('group_private') ? (
											<InputGroup
												label='Make item available only for selected DSOs?'
												markRequired={false}
												message={'If NO is selected, the item will be available to all the DSOs.'}
												error={error && error.dsoPrivate}
											>
												<RadioGroup
													name={'dso_private'}
													disabled={mappedDSOIds.length === 0}
													value={dsoPrivate}
													onClick={(e) => {
														this.handleInput('dsoPrivate', e.target.value === 'true');
													}}
													error={error && error.dsoPrivate}
													options={[
														{ name: 'Yes', value: true },
														{ name: 'No', value: false },
													]}
												/>
											</InputGroup>
										) : null}
									</SectionRow>
								</Section>
							) : null}

							<Section id='additional-information'>
								<SectionHeading>Additional Information</SectionHeading>

								<SectionRow>
									<InputGroup
										label='Alternate Text'
										markRequired={false}
										inputLength={(searchText || '').length}
										maxLength={200}
										message='Should contain alphabets, numbers, hyphens and spaces only.'
										info="Alternate Text is a supposed to have words which doesn't appear in the product but may be used to search a particular product. It doesn't boost the rank of a product for the provided words but ensures that the product is returned when a search has the words from alternate text."
										error={error && error.searchText}
									>
										<TextField
											name={'search_text'}
											disabled={false}
											placeholder='Enter value'
											value={searchText}
											onChange={(e) => {
												this.handleInput('searchText', e.target.value);
											}}
											onKeyUp={(e) => {
												this.checkErrors({ searchText: e.target.value });
											}}
											error={error && error.searchText}
										/>
									</InputGroup>

									{restrictedFields.includes('keywords') ? null : (
										<InputGroup
											label='Keywords'
											markRequired={false}
											inputLength={(keyword || '').length}
											maxLength={20}
											message='Should contain alphabets, numbers and hyphens only. Maximum 10 keywords are allowed.'
											info='Keywords is used to boost the ranking of a product for certain words. (The keywords should be token(s) which are already part of the product name, description, manufacturer name etc).'
											error={error && error.keyword}
										>
											<TextField
												name={'keyword'}
												disabled={false}
												placeholder='Type keyword and press Enter'
												value={keyword}
												onChange={(e) => {
													this.handleInput('keyword', e.target.value);
												}}
												onKeyUp={(e) => {
													if (e.target.value) {
														if (this.checkErrors({ keywords: keywords }) || this.checkErrors({ keyword: e.target.value })) {
															return;
														} else if (e.key === 'Enter') {
															this.handleInput('keywords', [...keywords, e.target.value]);
															this.handleInput('keyword', '');
														}
													}
												}}
												error={error && error.keyword}
												startAdornment={
													<InputAdornment>
														{keywords.map((word, index) => (
															<Chip
																size='small'
																label={word}
																onDelete={(e) => {
																	this.handleInput(
																		'keywords',
																		keywords.filter((keyword, i) => i !== index)
																	);
																}}
															/>
														))}
													</InputAdornment>
												}
											/>
										</InputGroup>
									)}

									{restrictedFields.includes('unspsc') ? null : (
										<InputGroup
											label='UNSPSC'
											markRequired={false}
											error={error && error.upspsc}
										>
											<TextField
												name={'unspsc'}
												disabled={false}
												placeholder='Enter value'
												value={unspsc}
												onChange={(e) => {
													this.handleInput('unspsc', e.target.value);
												}}
												error={error && error.unspsc}
											/>
										</InputGroup>
									)}

									<InputGroup
										label='Product URL'
										markRequired={false}
										error={error && error.productURL}
									>
										<TextField
											name={'product_url'}
											disabled={false}
											placeholder='Enter value'
											value={productURL}
											onChange={(e) => {
												this.handleInput('productURL', e.target.value);
											}}
											onKeyUp={(e) => {
												this.checkErrors({ productURL: e.target.value });
											}}
											error={error && error.productURL}
										/>
									</InputGroup>

									<FlexRow style={{ width: '100%' }}>
										<InputGroup
											label='Attributes'
											markRequired={false}
											message={'You may add different product attributes such as brand:colgate, dimensions:1mm*2mm*4mm, color:blue, etc.'}
											error={error && error.attributes}
										>
											{(attributes || []).length || true ? (
												<TableContainer>
													<Table>
														<TableHeader>
															<TableHeaderRow>
																<TableHeaderColumn
																	alignLeft
																	style={{ width: '50%' }}
																>
																	Key
																</TableHeaderColumn>

																<TableHeaderColumn
																	alignLeft
																	style={{ width: '50%' }}
																>
																	Value
																</TableHeaderColumn>

																<TableHeaderColumn
																	alignRight
																	style={{ width: '5.5rem', minWidth: '5.5rem' }}
																>
																	Action
																</TableHeaderColumn>
															</TableHeaderRow>
														</TableHeader>

														<TableBody>
															{attributes.map((attribute, index) => (
																<TableRow>
																	<TableColumn alignLeft>{attribute.key}</TableColumn>

																	<TableColumn alignLeft>{attribute.value}</TableColumn>

																	<TableColumn alignRight>
																		<FlexRow>
																			<ButtonGroup alignRight>
																				<SquareButton
																					secondary
																					outline
																					disabled={attributeIndex === index}
																					onClick={(e) => {
																						this.handleInput('attributeIndex', index);
																						this.handleInput('attributeKey', attribute.key);
																						this.handleInput('attributeValue', attribute.value);
																					}}
																				>
																					<EditIcon />
																				</SquareButton>

																				<SquareButton
																					error
																					outline
																					disabled={attributeIndex === index}
																					onClick={(e) => {
																						this.handleInput(
																							'attributes',
																							attributes.filter((attribute, i) => i !== index)
																						);
																					}}
																				>
																					<TrashIcon />
																				</SquareButton>
																			</ButtonGroup>
																		</FlexRow>
																	</TableColumn>
																</TableRow>
															))}

															<TableRow>
																<TableColumn>
																	<InputGroup
																		label=''
																		markRequired={false}
																		inputLength={(attributeKey || '').length}
																		maxLength={50}
																		error={error && error.attributeKey}
																		style={{ margin: '0rem' }}
																	>
																		<TextField
																			name='attribute_key'
																			placeholder='Enter key'
																			value={attributeKey}
																			onChange={(e) => {
																				this.handleInput('attributeKey', e.target.value);
																			}}
																			onKeyUp={(e) => {
																				this.checkErrors({ attributeKey: e.target.value });
																			}}
																			error={error && error.attributeKey}
																		/>
																	</InputGroup>
																</TableColumn>

																<TableColumn>
																	<InputGroup
																		label=''
																		markRequired={false}
																		inputLength={(attributeValue || '').length}
																		maxLength={50}
																		error={error && error.attributeValue}
																		style={{ margin: '0rem' }}
																	>
																		<TextField
																			name='attribute_value'
																			placeholder='Enter value'
																			value={attributeValue}
																			onChange={(e) => {
																				this.handleInput('attributeValue', e.target.value);
																			}}
																			onKeyUp={(e) => {
																				this.checkErrors({ attributeValue: e.target.value });
																			}}
																			error={error && error.attributeValue}
																		/>
																	</InputGroup>
																</TableColumn>

																<TableColumn alignRight>
																	<FlexRow style={{ marginTop: '18px' }}>
																		<ButtonGroup alignRight>
																			<Button
																				fullWidth
																				secondary
																				onClick={(e) => {
																					if (this.checkErrors({ attributeKey: attributeKey }) || this.checkErrors({ attributeValue: attributeValue })) {
																						return;
																					}

																					if (attributeIndex === -1) {
																						this.handleInput('attributes', [...attributes, { key: attributeKey, value: attributeValue }]);
																					} else {
																						this.handleInput(
																							'attributes',
																							attributes.map((attribute, i) => {
																								if (i === attributeIndex) {
																									return { key: attributeKey, value: attributeValue };
																								}
																								return attribute;
																							})
																						);
																					}

																					this.handleInput('attributeKey', '');
																					this.handleInput('attributeValue', '');
																					this.handleInput('attributeIndex', -1);
																				}}
																			>
																				Add Attribute
																			</Button>
																		</ButtonGroup>
																	</FlexRow>
																</TableColumn>
															</TableRow>
														</TableBody>
													</Table>
												</TableContainer>
											) : null}
										</InputGroup>
									</FlexRow>
								</SectionRow>
							</Section>
						</FlexColumn>
					</FlexRow>
				</ContainerBody>
			</Container>
		);
	}
}

const mapStateToProps = (state) => {
	let restrictedFields = getRestrictedFields(state.session, state.supplier);
	let allowZeroPrice = state?.supplier?.sellerPortalConfig?.allow_zero_pricing || false;

	return {
		supplier: state.supplier.supplier,
		supplierMap: state.supplier.suppliers_map,
		groupId: state.session.groupId,
		manufacturerOptions: state.inventory.manufacturerOptions || [],
		mappedSupplierOptions: state.inventory.mappedSupplierOptions || [],
		uomOptions: state.inventory.packagingOptions || [],
		packagingOptions: state.inventory.packagingOptions || [],
		mappedDSOOptions: state.inventory.mappedDSOOptions || [],
		categoryOptions: state.inventory.categoryOptions || [],
		subCategoryOptions: state.inventory.subCategoryOptions || [],
		subSubCategoryOptions: state.inventory.subSubCategoryOptions || [],
		restrictedFields: restrictedFields,
		allowZeroPrice
	};
};

const mapDispatchToProps = {
	updateError,
	updateErrorMessage,
	updateMessage,
	updateSuccessMessage,
	uploadFile,
	fetchFileUploadURL,
	fetchAutocompleteSubCategory,
	fetchAutocompleteSubSubCategory,
	createInventory,
	fetchInventory,
	updateInventory,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddSingleItem));
